module.exports = __webpack_public_path__ + "static/media/tk-logo_2x.2f74d66a.png";